import clsx from "clsx";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

/**
 * SmartActionButtons Component
 * Displays context-aware action buttons in a 2-column grid layout
 * NO bubble container, NO labels like "Snapshot 1" or "image ready"
 * Buttons appear as a clean extension below the AI response
 * @param {Array} actions - Array of smart action objects
 * @param {Function} onActionClick - Callback when an action button is clicked
 * @param {boolean} isLoading - Whether actions are being generated
 * @param {boolean} disabled - Whether buttons should be disabled
 * @param {boolean} showHeader - Deprecated, kept for backward compatibility but ignored
 */
const SmartActionButtons = ({ actions = [], onActionClick, isLoading = false, disabled = false, showHeader = false }) => {
    const { selectedActionId } = useSelector((state) => state.askAIReducer);

    // Loading state - show only typing indicator without header
    if (isLoading) {
        return (
            <div className='askai-smart-actions askai-smart-actions-clean'>
                <div className='askai-smart-actions-loading'>
                    <div className='askai-typing-indicator'>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        );
    }

    if (isEmpty(actions)) {
        return null;
    }

    const handleActionClick = (action) => {
        if (disabled) return;
        onActionClick(action);
    };

    // Render only action buttons - no bubble container, no headers, no labels
    return (
        <div className='askai-smart-actions askai-smart-actions-clean'>
            <div className='askai-smart-actions-grid'>
                {actions.map((action, index) => (
                    <div key={action.id || `action-${index}`} className='custom-tooltip top-tooltip center-tooltip m-hide'>
                        <button
                            className={clsx("askai-action-btn", disabled && "disabled", selectedActionId === action.id && "selected")}
                            onClick={() => handleActionClick(action)}
                            disabled={disabled}
                        >
                            <span className='action-label'>{action.label}</span>
                        </button>
                        <div className='custom-tooltip-content text-center'>
                            <div className='custom-tooltip-in'>
                                <p>{action.reason || action.prompt}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SmartActionButtons;
